import { createContext } from 'react';

import { Dispatch, Action } from 'redux';

import { UserDashboards, WidgetItem, UserPermission, ChatUser } from '@vyce/core/src/types';
import { WidgetWrapperProps } from '../components/Dashboard/WidgetWrapper';
import { getDormantWorkersRequest } from '../api/time';

interface Context {
  dashboards?: UserDashboards;
  name?: string;
  selectedCompanyId: string;
  timePermission: boolean;
  teamPermission: boolean;
  widgetComponent: (props: { widget: WidgetItem; redirectUrl?: string } & WidgetWrapperProps) => JSX.Element;
  inviteButtonComponent?: () => JSX.Element;
  updateUserDashboards: (dashboards: UserDashboards) => (dispatch: Dispatch<Action>) => Promise<void>;
  onOpenUniversalInviteForm?: () => void;
  chatUser?: ChatUser;
  // Overridable dormant-workers fetcher: pay-app uses the public/v1 default,
  // legend-app injects the admin/v1 variant.
  fetchDormantWorkers?: typeof getDormantWorkersRequest;
}

export const TimeDashboardModuleContext = createContext({} as Context);

export const TimeDashboardModuleProvider = TimeDashboardModuleContext.Provider;
